import React from 'react';
import {
    Col, Row, Table,
} from 'react-bootstrap';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import { API_ROOT } from '../../variables/api-config';

class VerEvento extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  drawFileData(archivos) {
    return archivos.map((item, index) => {
      return (
        <tr key={index}>
          <td style={{textAlign: 'left'}}>{item.nombre}</td>
          <td>{item.descripcion}</td>
          <td style={{textAlign: 'right'}}>
            <Button simple bsStyle="info" bsSize="xs">
              <a href={`${API_ROOT}/calendar/event/download/file?id=${item.id}`}>
                <i className="fa fa-download"></i>
              </a>
            </Button>
          </td>
        </tr>
      )
    })
  }

  render() {
    const evento = {...this.props.evento};
    let inicio;
    let finalizacion;
    const todoeldia = parseInt(evento.todoeldia, 10);
    if (todoeldia) {
      inicio = new Date(evento.fechainicio).toLocaleString().split(' ')[0];
      finalizacion = new Date(evento.fechafin).toLocaleString().split(' ')[0];
    } else {
      inicio = new Date (`${evento.fechainicio}T${evento.horainicio}`).toLocaleString();
      finalizacion = new Date(`${evento.fechafin}T${evento.horafin}`).toLocaleString();
    }
    return(
      <div>
        <Row>
          <Col md={12}>
            <h3>{evento.nombre}</h3>
            <h4>{evento.descripcion}</h4>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <p><strong>Tipo:</strong></p>
          </Col>
          <Col md={8}>
            <p>{evento.tipo}</p>
          </Col>
          <Col md={4}>
            <p><strong>{todoeldia ? 'Fecha Inicio:' : 'Inicio:'}</strong></p>
          </Col>
          <Col md={8}>
            <p>{inicio}</p>
          </Col>
          <Col md={4}>
            <p><strong>{todoeldia ? 'Fecha Fin:' : 'Finalizacion:'}</strong></p>
          </Col>
          <Col md={8}>
            <p>{finalizacion}</p>
          </Col>
          <Col md={4}>
            <p><strong>Lugar:</strong></p>
          </Col>
          <Col md={8}>
            <p>{evento.lugar}</p>
          </Col>
        </Row>
        {evento.archivos.length > 0 &&
          <Row>
            <Col md={12}>
              <p><strong>Archivos:</strong></p>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.drawFileData(evento.archivos)}
                </tbody>
              </Table>
            </Col>
          </Row>
        }
      </div>
    )
  }
}

export default VerEvento;



// WEBPACK FOOTER //
// ./src/views/Calendar/ModalVerEvento.jsx